import { BTN_SIZE } from './d200-layout';

async function canvasToArrayBuffer(
  canvas: OffscreenCanvas,
): Promise<ArrayBuffer> {
  const blob = await canvas.convertToBlob({ type: 'image/png' });
  return blob.arrayBuffer();
}

function createCanvas(
  width: number,
  height: number,
): [OffscreenCanvas, OffscreenCanvasRenderingContext2D] {
  const canvas = new OffscreenCanvas(width, height);
  const ctx = canvas.getContext('2d') as OffscreenCanvasRenderingContext2D;
  return [canvas, ctx];
}

export async function renderMaterialButton(
  mnemonic: string,
  hue: number,
  width = BTN_SIZE,
  height = BTN_SIZE,
): Promise<ArrayBuffer> {
  const [canvas, ctx] = createCanvas(width, height);

  ctx.fillStyle = `hsla(${hue}, 65%, 50%, 0.85)`;
  ctx.fillRect(0, 0, width, height);

  ctx.fillStyle = '#fff';
  ctx.textAlign = 'center';
  ctx.textBaseline = 'middle';

  const maxLen = 6;
  const display =
    mnemonic.length > maxLen ? mnemonic.substring(0, maxLen) : mnemonic;
  const fontSize = display.length <= 3 ? 48 : 36;
  ctx.font = `600 ${fontSize}px sans-serif`;
  ctx.fillText(display, width / 2, height / 2, width - 16);

  return canvasToArrayBuffer(canvas);
}

export async function renderDigitButton(
  digit: string,
  width = BTN_SIZE,
  height = BTN_SIZE,
): Promise<ArrayBuffer> {
  const [canvas, ctx] = createCanvas(width, height);

  ctx.fillStyle = '#1a1a1a';
  ctx.fillRect(0, 0, width, height);

  ctx.fillStyle = '#fff';
  ctx.font = '600 72px sans-serif';
  ctx.textAlign = 'center';
  ctx.textBaseline = 'middle';
  ctx.fillText(digit, width / 2, height / 2);

  return canvasToArrayBuffer(canvas);
}

export async function renderActionButton(
  text: string,
  bgColor: string,
  textColor: string,
  width = BTN_SIZE,
  height = BTN_SIZE,
): Promise<ArrayBuffer> {
  const [canvas, ctx] = createCanvas(width, height);

  ctx.fillStyle = bgColor;
  ctx.fillRect(0, 0, width, height);

  ctx.fillStyle = textColor;
  ctx.font = '600 44px sans-serif';
  ctx.textAlign = 'center';
  ctx.textBaseline = 'middle';
  ctx.fillText(text, width / 2, height / 2, width - 16);

  return canvasToArrayBuffer(canvas);
}

export async function renderWideButton(
  text: string,
  bgColor: string,
  textColor: string,
  width: number,
  height = BTN_SIZE,
): Promise<ArrayBuffer> {
  const [canvas, ctx] = createCanvas(width, height);

  ctx.fillStyle = bgColor;
  ctx.fillRect(0, 0, width, height);

  const circleR = 24;
  const circleX = 48;
  const circleY = height / 2;
  ctx.beginPath();
  ctx.arc(circleX, circleY, circleR, 0, Math.PI * 2);
  ctx.fillStyle = 'rgba(255,255,255,0.25)';
  ctx.fill();

  ctx.fillStyle = textColor;
  ctx.font = '600 36px sans-serif';
  ctx.textAlign = 'center';
  ctx.textBaseline = 'middle';
  const textX = (width + circleX + circleR) / 2;
  ctx.fillText(text, textX, height / 2, width - circleX - circleR - 24);

  return canvasToArrayBuffer(canvas);
}

export async function renderPaginationButton(
  direction: 'next' | 'prev',
  width = BTN_SIZE,
  height = BTN_SIZE,
): Promise<ArrayBuffer> {
  const [canvas, ctx] = createCanvas(width, height);

  ctx.fillStyle = '#1a1a1a';
  ctx.fillRect(0, 0, width, height);

  ctx.fillStyle = '#fff';
  ctx.font = '600 64px sans-serif';
  ctx.textAlign = 'center';
  ctx.textBaseline = 'middle';
  ctx.fillText(direction === 'next' ? '▶' : '◀', width / 2, height / 2);

  return canvasToArrayBuffer(canvas);
}

export async function renderEmptyButton(
  width = BTN_SIZE,
  height = BTN_SIZE,
): Promise<ArrayBuffer> {
  const [canvas, ctx] = createCanvas(width, height);

  ctx.fillStyle = '#000';
  ctx.fillRect(0, 0, width, height);

  return canvasToArrayBuffer(canvas);
}
